module.exports = __webpack_public_path__ + "img/photo-0032.f7c3f720.jpg";